import React, {lazy, Suspense} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Loading from 'components/shared-components/Loading';
import {AUTH_PREFIX_PATH} from 'configs/AppConfig';
import {connect} from 'react-redux';

export const AppViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${AUTH_PREFIX_PATH}/login`}
					component={lazy(() => import(`./authentication/login-2`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/register`}
					component={lazy(() => import(`./authentication/register-2`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/complete-invitation`}
					component={lazy(() => import(`./authentication/complete-invitation`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/onboarding`}
					component={lazy(() => import(`./onboarding`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/forgot-password`}
					component={lazy(() => import(`./authentication/forgot-password`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/reset-password`}
					component={lazy(() => import(`./authentication/reset-password`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/logout`}
					component={lazy(() => import(`./authentication/logout`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/error`}
					component={lazy(() => import(`./errors/error-page-1`))}
				/>
				<Redirect
					from={`${AUTH_PREFIX_PATH}`}
					to={`${AUTH_PREFIX_PATH}/login`}
				/>
			</Switch>
		</Suspense>
	);
};

const mapStateToProps = (state) => {
	return {
		redirect: state.auth.redirect,
	};
};

export default connect(mapStateToProps)(AppViews);
